const SizeSorting = {
  "6C": {
    order: 1,
  },
  "7C": {
    order: 2,
  },
  "8C": {
    order: 3,
  },
  "9C": {
    order: 4,
  },
  "10C": {
    order: 5,
  },
  "11C": {
    order: 6,
  },
  "12C": {
    order: 7,
  },
  "13C": {
    order: 8,
  },
  "1Y": {
    order: 9,
  },
  "2Y": {
    order: 10,
  },
  "3Y": {
    order: 11,
  },
  "3.5Y": {
    order: 12,
  },
  "4Y": {
    order: 13,
  },
  "4.5Y": {
    order: 14,
  },
  "5Y": {
    order: 15,
  },
  "5.5Y": {
    order: 16,
  },
  "6Y": {
    order: 17,
  },
  "6.5Y": {
    order: 18,
  },
  "7Y": {
    order: 19,
  },
};
const initiFindifyFilter = () => {
  const filterCheckboxSelector = `.findify-filters-checkbox-item`;

  const getValue = (item, array) => {
    const value = item.getAttribute("value");
    if (array[value]) return array[value];
    else return value;
  };
  const sortItems = (selector, array) => {
    const body = document.querySelector(selector);
    const items = body?.querySelectorAll(`${filterCheckboxSelector}`);
    if (!items) return;
    const sortedItems = Array.from(items).sort(
      (a, b) => getValue(a, array) - getValue(b, array),
    );

    body.innerHTML = "";
    sortedItems.forEach((item) => {
      body.appendChild(item);
    });
  };
  sortItems(
    `[id="findify-filters-custom_fields.size_kids"] .findify-filters--body-wrapper`,
    SizeSorting,
  );
  sortItems(
    `[id="findify-filters-custom_fields.size_adults"] .findify-filters--body-wrapper`,
    SizeSorting,
  );
};
